import { IBrandSafetyRule } from '~/src/dash/api/brand-safety-rules';
import { IUser } from '~/src/dash/api/console-api';
import { ICreativeValidationRowData } from '~/src/dash/components/list-table';
import { IMenuList } from '~/src/dash/types/menuList';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';

export const generateBSRMenuForCreativeValidationRow = (
  user: IUser,
  brandSafetyRules: IBrandSafetyRule[],
  creativeValidationRowData: ICreativeValidationRowData,
) => {
  const newMenuListBrandSafetyRule = {} as IMenuList;
  for (const brandSafetyRule of brandSafetyRules) {
    const splitBSRCategories =
      brandSafetyRule.TargetedIABs !== '' ? brandSafetyRule.TargetedIABs.split(',') : [];
    const splitCVRCategories =
      creativeValidationRowData.IABCategoryCodes !== ''
        ? creativeValidationRowData.IABCategoryCodes.split(';')
        : [];

    for (const cvrCategory of splitCVRCategories) {
      if (splitBSRCategories.includes(cvrCategory)) {
        const brandSafetyRuleName = checkUserInfoMasked(user)
          ? `demo_rule_${brandSafetyRule.ID}`
          : brandSafetyRule.Name;
        newMenuListBrandSafetyRule[brandSafetyRule.ID] = {
          title: brandSafetyRuleName,
          selected: (creativeValidationRowData.BrandSafetyRuleIDs || []).includes(
            brandSafetyRule.ID,
          )
            ? true
            : false,
          ID: brandSafetyRule.ID.toString(),
        };
        break;
      }
    }
  }

  return newMenuListBrandSafetyRule;
};

// examples
// getDomain('http://www.example.com'); // example.com
// getDomain('www.example.com'); // example.com
// getDomain('http://blog.example.com', true); // blog.example.com
export const getDomain = (url: any, subdomain?: boolean) => {
  subdomain = subdomain || false;

  url = url.replace(/(https?:\/\/)?(www.)?/i, '');

  if (!subdomain) {
    url = url.split('.');
    url = url.slice(url.length - 2).join('.');
  }

  if (url.indexOf('/') !== -1) {
    return url.split('/')[0];
  }

  return url;
};
